import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './Discussions.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
// import { Bling as GPT } from "react-gpt";
import User from './common/User';
import DiscussionLinks from './common/DiscussionLinks';
import DiscussionContent from './common/DiscussionContent';
import CommentOverlay from './common/CommentOverlay';
import UserListOverlay from './common/UserListOverlay';
import Cookies from 'js-cookie';
import copy from 'copy-to-clipboard';
import withLocation from "../../withLocation";
import { AdSlot, DFPSlotsProvider } from 'react-dfp'


const service = new Service();

class Discussions extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        let userId = Cookies.get('_$FC_UserInfo$_');
        this.totalCount = 0;
        let isWindow = false;
        let isDesktop = true;
        if (__isBrowser__) {
            isWindow = true;
            if (window.innerWidth < 768) {
                isDesktop = false;
            }
        }
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['result']) {
            initialData = serverSideData['result'];
            this.totalCount = parseInt(serverSideData['discussionCount']);
        }
        this.state = {
            displayCpnPopup: false,
            displaySorryPopup: false,
            isCouponVisible: '',
            couponTitle: '',
            couponCode: '',
            couponDescription: '',
            hyperlink:'',
            mapwith: '',
            activityId: '',
            couponId: '',
            user_id: userId,
            initialData: initialData,
            metaTitle: "Discussions on Pregnancy, Parenting, Baby Care & more",
            metaDescription: [
                { "name": "description", "content": "Join the Firstcry Parenting discussions and be a part of one of the largest & active online communities. Discuss & stay updated on a host of useful & interesting topics." }
            ],
            banner_redirection_url: '',
            banner_asset: '',
            banner_heading: '',
            aasset_mobile: '',
            aasset_desktop: '',
            banner_heading: '',
            isWindow: isWindow,
            isDesktop: isDesktop
        };

        this.disPageNo = 1;
        if (this.props.params.page && this.props.params.page > 0) {
            this.disPageNo = parseInt(this.props.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 10;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }
        var url = global.api_url + "discussion/getdiscussionlist";
        let body = JSON.stringify({
            "pagesize": size,
            "pageno": 1
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    modifyLinks = (htmlString) => {
        // Add target="_blank" to all <a> tags
        return htmlString.replace(/<a /g, '<a target="_blank" ');
    };

    componentDidMount() {
        // Initialize AdPushup
        if (typeof window !== "undefined") {
            window.adpushup = window.adpushup || {};
            window.adpushup.que = window.adpushup.que || [];

            // Push the trigger after DOM is ready
            window.adpushup.que.push(() => {
            window.adpushup.triggerAd("8bd7c258-61a1-4807-91f8-866d8b1118ec");
            });
        }

        document.addEventListener("click", actions.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        if (navigator.onLine) {
            let size = 10;
            if (this.disPageNo > 1) {
                size = 10 * this.disPageNo;
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.discussionData(1, size);
            } else {
                localStorage.setItem('discussionLanding', JSON.stringify(this.state.initialData));
                localStorage.setItem('discussionLandingCnt', JSON.stringify(this.totalCount));
                actions.loadSliders();
                actions.loadReadMore();
            }
        } else {
            if (localStorage.getItem('discussionLanding')) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('discussionLanding')) }, () => { actions.loadSliders(); actions.loadReadMore(); });
            }
            if (localStorage.getItem('discussionLandingCnt')) {
                this.totalCount = localStorage.getItem('discussionLandingCnt');
            }
            service.hideLoader();
        }
        actions.setWidth();
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", actions.domClick);
    }

    appendURL() {
        window.location.href = service.getRedirectUrl("/discussions/t/page/" + this.disPageNo);
        // this.props.history.push(service.getRedirectUrl("/discussions/page/" + this.disPageNo));
    }

    pageData() {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.disPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.disPageNo;
                        service.showLoader();
                        service.showTracking();
                        _this.discussionData(_this.disPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    discussionData(pageno, size) {
        var postData = {
            "pagesize": size,
            "pageno": pageno
        }
        var url = global.api_ci_url + "Discussions/getdiscussionlist";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                if (this.state.initialData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ initialData: json['result'] }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.initialData;
                        this.setState({ initialData: ary.concat(json['result']) }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); });
                    }
                    // if (parseInt(pageno) != 1) {
                    //     this.appendURL();
                    // }
                } else {
                    localStorage.setItem('discussionLanding', JSON.stringify(json['result']));
                    localStorage.setItem('discussionLandingCnt', JSON.stringify(json['discussionCount']));
                    this.totalCount = parseInt(json['discussionCount']);
                    this.setState({ initialData: json['result'] }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });
    }

    reloadData() {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            _this.discussionData(_this.disPageNo, (_this.disPageNo * 10));
        }, 500)
    }

    closePopup(){
        const congratsPopup = document.getElementById("coupon_pop_overlay");
        congratsPopup.style.display = "none";
        document.getElementsByTagName('html')[0].style.overflow = 'auto';
    }
    closeBannerPopup = (event) => {
        const congratsPopup = document.getElementById("suggestion-banner-popup");
        document.getElementsByTagName('html')[0].style.overflow = 'visible';
        congratsPopup.style.display = "none";
        this.setState({ banner_redirection_url: '', aasset_mobile: '', banner_heading: '', aasset_desktop:'' });
    }
    closeSorryPopup= ()=>{
        const sorryPopup = document.getElementById("sorry_pop_overlay");
        sorryPopup.style.display = "none";
        document.getElementsByTagName('html')[0].style.overflow = 'auto';
    }
    closeThankYouPopup= (event)=>{
        const thankyouPopup = document.getElementById("quiz_thankyou_overlay");
        thankyouPopup.style.display = "none";
        document.getElementsByTagName('html')[0].style.overflow = 'visible';
    }
    usePopup=()=>{
        
        // window.location.href = this.state.hyperlink;
        const hyperlink = this.state.hyperlink;
        const url1 = hyperlink.startsWith('https') ? hyperlink : `https://${hyperlink}`;
        window.open(url1, '_blank');

        var postData = {
            "mapwith": this.state.mapwith,
            "activityId": this.state.activityId,
            "couponId": this.state.couponId,
            "user_Id": this.state.user_id
        }

        var url = global.api_ci_url + "Quiz/setcouponviewflag";
        // console.log("api_ci_url:::", global.api_ci_url);
        service.postServiceCall(url, postData).then((json) => {
            // console.log("getdata response",json);
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });

    }

    cpncodeclick = () => {
        const text = document.getElementById("cpn_code").textContent;
        copy(text, {
            debug: true,
            message: 'Coupon code copied!!'
        });

        const toastElements = document.getElementsByClassName('cpn_pop_toast');
        if (toastElements.length > 0) {
            toastElements[0].style.display = 'block';

            setTimeout(() => {
                toastElements[0].classList.add('fadeout');
                setTimeout(() => {
                    toastElements[0].style.display = 'none';
                }, 1000);
            }, 1500); 
        }
    }

    render() {
        console.log("this.props ======", this.props);
        const { couponDescription } = this.state;
        const updatedDescription = this.modifyLinks(couponDescription);

        return (
            <main className="discussions-main main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <meta name="atdlayout" content="discussions" />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Discussions</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Discussions</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        {this.state.initialData && this.state.initialData.map((discussion, index) =>
                            <div key={index}>
                                <div className="discussion-block" data-title={discussion.title} data-id={discussion.discussionId} id={`discussion_${discussion.discussionId}`}>
                                    <Link to={service.getRedirectUrl(`/discussions/t/${service.replaceSymbols((discussion.title) + '-' + (discussion.discussionId))}`)}>
                                        <User user={discussion} isAnonymus={0} eleRef={this} />
                                    </Link>
                                    <DiscussionContent discussion={discussion} linkUrl={`/discussions/t/${service.replaceSymbols((discussion.title) + '-' + (discussion.discussionId))}`} isDisLanding={true} eleRef={this} />
                                    <div className="divider_line"></div>
                                    <DiscussionLinks discussion={discussion} eleRef={this} />
                                </div>
                                {__isBrowser__ && index == 0 &&
                                    <div>
                                        {/* for india */}
                                        {/* <div id="vdo_ai_div"></div><script>{(function (v, d, o, ai) { ai = d.createElement('script'); ai.defer = true; ai.async = true; ai.src = v.location.protocol + o; d.head.appendChild(ai); })(window, document, '//a.vdo.ai/core/v-parenting-firstcry-v2/vdo.ai.js')}</script> */}
                                        {/* for outside india */}
                                        {/* <div id="vdo_ai_div"></div><script>{(function (v, d, o, ai) { ai = d.createElement('script'); ai.defer = true; ai.async = true; ai.src = v.location.protocol + o; d.head.appendChild(ai); })(window, document, '//a.vdo.ai/core/v-parenting-firstcry-v3/vdo.ai.js')}</script> */}
                                    </div>
                                }
                                {((index + 1) % 4 == 0) &&
                                    <div>
                                        <div className="desktop-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                        <div style={{textAlign: "center", padding:"5px"}} >ADVERTISEMENT</div> 
                                            <div id="div-gpt-ad-1592993533680-0" style={{ width: '696px', height: '200px', overflow: 'hidden', margin: '0 auto' }}>
                                                {/* <GPT
                                                    adUnitPath="/84382175/parenting.com/parenting.com_Discussion_Desktop"
                                                    slotSize={[[696, 200], [336, 280], [728, 90], [300, 250]]}
                                                /> */}
                                                <DFPSlotsProvider
                                                    // dfpNetworkId={gptAry['desktop']['id']}
                                                    adUnitPath="/84382175/parenting.com/parenting.com_Discussion_Desktop"
                                                    slotSize={[[696, 200], [336, 280], [728, 90], [300, 250]]}
                                                ></DFPSlotsProvider>
                                            </div>
                                        </div>
                                        <div className="msite-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                        <div style={{textAlign: "center", padding:"5px"}} >ADVERTISEMENT</div> 
                                            <div id="div-gpt-ad-1592993525621-0" style={{ width: '320px', height: '50px', overflow: 'hidden', margin: '0 auto' }}>
                                                {/* <GPT
                                                    adUnitPath="/84382175/parenting.com/parenting.com_Discussion_Msite"
                                                    slotSize={[[336, 280], [300, 250], [320, 100], [320, 50]]}
                                                /> */}
                                                <DFPSlotsProvider
                                                    // dfpNetworkId={gptAry['desktop']['id']}
                                                    adUnitPath="/84382175/parenting.com/parenting.com_Discussion_Msite"
                                                    slotSize={[[336, 280], [300, 250], [320, 100], [320, 50]]}
                                                ></DFPSlotsProvider>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        )}
                        {(!this.state.initialData || this.state.initialData.length < 1) &&
                            <div className="discussion-block"></div>
                        }
                    </div>
                </div>
                <input type="hidden" id="post_commentId" value="" />
                <input type="hidden" id="post_parentUserId" value="" />
                <input type="hidden" id="post_parentUserName" value="" />
                <input type="hidden" id="post_parentIsAnonymus" value="" />
                <input type="hidden" id="post_replyId" value="" />
                <input type="hidden" id="post_dId" value="" />
                <input type="hidden" id="post_gId" value="" />
                <input type="hidden" id="post_cId" value="" />
                <input type="hidden" id="post_dUrl" value="" />
                <CommentOverlay eleRef={this} />
                <UserListOverlay eleRef={this} />
                <div className="share-overlay"></div>
                <Right url={this.props.location.pathname} />

                {/* {
                    this.state.banner_redirection_url && 
                    <div id="suggestion-banner-popup" className="suggestion-banner-popup">
                        <div className="banner-popup-content">
                            <div className="banner-popup-close" onClick={this.closeBannerPopup} data-icon-font="C"></div>
                            <div className="banner-popup-image-wrapper">
                            <div className="banner-popup-heading M16_21">{this.state.banner_heading}</div>
                            <div className="banner-popup-image">
                                <a href={this.state.banner_redirection_url} target="_blank" rel="noopener noreferrer">
                                    <img src={this.state.banner_asset} alt={this.state.banner_heading} />
                                </a>
                            </div>
                            </div>
                            
                            
                        </div>
                    </div>
                 } */}
                 {/* Banner Popup code start here */}
                    {
                    this.state.aasset_desktop && this.state.banner_redirection_url && this.state.isDesktop &&
                    <div id="suggestion-banner-popup" className="suggestion-banner-popup">
                        <div className="banner-popup-content">
                            <div className="banner-popup-close" onClick={this.closeBannerPopup} data-icon-font="C"></div>
                            <div className="banner-popup-image-wrapper">
                            {this.state.banner_heading &&
                            <div className="banner-popup-heading M16_21">{this.state.banner_heading}</div>
                            }
                            <div className="banner-popup-image">
                                <a href={this.state.banner_redirection_url} target="_blank" rel="noopener noreferrer">
                                    <img src={this.state.aasset_desktop} alt={this.state.banner_heading} />
                                </a>
                            </div>
                            </div>
                            
                            
                        </div>
                    </div>
                 }            
                 {
                    this.state.aasset_mobile && this.state.banner_redirection_url && !this.state.isDesktop &&
                    <div id="suggestion-banner-popup" className="suggestion-banner-popup">
                        <div className="banner-popup-content">
                            <div className="banner-popup-close" onClick={this.closeBannerPopup} data-icon-font="C"></div>
                            <div className="banner-popup-image-wrapper">
                            {this.state.banner_heading &&
                            <div className="banner-popup-heading M16_21">{this.state.banner_heading}</div>
                            }
                            <div className="banner-popup-image">
                                <a href={this.state.banner_redirection_url} target="_blank" rel="noopener noreferrer">
                                    <img src={this.state.aasset_mobile} alt={this.state.banner_heading} />
                                </a>
                            </div>
                            </div>
                            
                            
                        </div>
                    </div>
                 }               
                
                {/* Banner Popup code end here */}


                {/* {
                    this.state.banner_redirection_url && 
                    <div id="suggestion-banner-popup" className="suggestion-banner-popup">
                        <div className="banner-popup-content">
                            <div className="banner-popup-close" onClick={this.closeBannerPopup} data-icon-font="C"></div>
                            <div className="banner-popup-image-wrapper">
                            <div className="banner-popup-heading M16_21">{this.state.banner_heading}</div>
                            <div className="banner-popup-image">
                                <a href={this.state.banner_redirection_url} target="_blank" rel="noopener noreferrer">
                                    <img src={this.state.banner_asset} alt={this.state.banner_heading} />
                                </a>
                            </div>
                            </div>
                            
                            
                        </div>
                    </div>
                 } */}
                 {/* Banner Popup code start here */}
                    {
                    this.state.aasset_desktop && this.state.banner_redirection_url && this.state.isDesktop &&
                    <div id="suggestion-banner-popup" className="suggestion-banner-popup">
                        <div className="banner-popup-content">
                            <div className="banner-popup-close" onClick={this.closeBannerPopup}>
                                <img src="https://cdn.cdnparenting.com/brainbees/community/images/ic-cross.svg" alt="close icon" title="close icon" />
                            </div>
                            <div className="banner-popup-image-wrapper">
                            {this.state.banner_heading &&
                            <div className="banner-popup-heading M16_21">{this.state.banner_heading}</div>
                            }
                            <div className="banner-popup-image">
                                <a href={this.state.banner_redirection_url} target="_blank" rel="noopener noreferrer">
                                    <img src={this.state.aasset_desktop} alt={this.state.banner_heading} />
                                </a>
                            </div>
                            </div>
                            
                            
                        </div>
                    </div>
                 }            
                 {
                    this.state.aasset_mobile && this.state.banner_redirection_url && !this.state.isDesktop &&
                    <div id="suggestion-banner-popup" className="suggestion-banner-popup">
                        <div className="banner-popup-content">
                            <div className="banner-popup-close" onClick={this.closeBannerPopup} >
                                <img src="https://cdn.cdnparenting.com/brainbees/community/images/ic-cross.svg" alt="close icon" title="close icon" />
                            </div>
                            <div className="banner-popup-image-wrapper">
                            {this.state.banner_heading &&
                            <div className="banner-popup-heading M16_21">{this.state.banner_heading}</div>
                            }
                            <div className="banner-popup-image">
                                <a href={this.state.banner_redirection_url} target="_blank" rel="noopener noreferrer">
                                    <img src={this.state.aasset_mobile} alt={this.state.banner_heading} />
                                </a>
                            </div>
                            </div>
                            
                            
                        </div>
                    </div>
                 }               
                
                {/* Banner Popup code end here */}


                 {/* coupon popup code start */}
                 <div className="coupon_pop_overlay" id='coupon_pop_overlay' style={{display: this.state.displayCpnPopup ? 'block' : 'none',}}>    
                    <div className="coupon_popup">
                        <div className="cross_ic_wrap">
                            <div className="close_btn" onClick={this.closePopup}  data-icon-font="C"></div>
                        </div>   
                        <div className="pop_confetti">
                            <lottie-player className="animate" background="transparent" speed="1" loop autoplay src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pop_confetti.json" style={{'width':'450px','height':'auto'}}></lottie-player>
                        </div>
                        <div className="coupon_pop_body">
                            <div className="pop_head_sec">
                                <div className="pop_heading B22_21">{this.state.couponTitle}</div>
                                <div className="cpn_code_sec">
                                    <div className="cpn_code_wrap"><div className="cpn_code B16_FF" id='cpn_code'>{this.state.couponCode}</div></div>
                                    <div className="clk_to_copy M16_pink" onClick={this.cpncodeclick}>CLICK TO COPY</div>
                                </div>
                            </div>
                            <div className="pop_divider_img">
                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/ds_divider.png" alt="divider" title="divider" />
                            </div>
                            <div className="cpn_pop_toast" ><span className="R14_white">Coupon code copied!!</span></div>
                            <div className="pop_desc_sec">
                                <div className="desc_title M15_21">Offer Details</div>
                                <div className="pop_desc R15_42">
                                    <ol>
                                        <div
                                            className="pop_desc R15_42"
                                            dangerouslySetInnerHTML={{ __html: updatedDescription }}
                                        />
                                    </ol>
                                </div>
                                <div className="pop_hr_line"></div>
                                <div className="use_now_btn M16_FF"  onClick={this.usePopup}>USE NOW</div>
                                <div className="pop_note R14_42">Find all coupons under <a href={`${global.hosturl}my-account/my-earnings`} target="_blank" className="R14_link">My Rewards & Coupons</a> section in Parenting Activities</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sorry_pop_overlay" id='sorry_pop_overlay' style={{display: this.state.displaySorryPopup ? 'block' : 'none',}}>
                    <div className="cross_ic_wrap">
                        <div className="close_btn" onClick={this.closeSorryPopup} data-icon-font="C"></div>
                    </div>                    
                    <div className="sorry_popup">
                        <div className="cross_ic_wrap">
                            <div className="close_btn" onClick={this.closeSorryPopup} data-icon-font="C"></div>
                        </div> 
                        <div className="sorry_pop_body">
                            <div className="top_pink_half"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink_round1.png" alt="pink half circle" title="pink half circle"/></div>
                            <div className="content_wrap">    
                                <div className="heading B24_21">Sorry, You Were Close!</div>
                                <div className="sub_text R16_42">Participate in more Quizzes, Contests & Discussions and stand a chance to win different prizes!</div>
                            </div>
                            <div className="bottom_pink_half"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink_round2.png" alt="pink half circle" title="pink half circle"/></div>
                        </div>
                    </div>
                </div>
                <script src="https://cdn.fcglcdn.com/brainbees/js/m1/json/lottiejson/lottie-player.v2.0.2.min.js"></script>

                {/* coupon popup code end */}
                <div className="quiz_thank_you_overlay" id="quiz_thankyou_overlay" style={{ display: 'none' }}>
                    <div className="quiz_thank_you_pop">
                        <div className="close_btn_wrap">
                            <div className="close_btn" onClick={this.closeThankYouPopup} data-icon-font="C"></div>
                        </div>
                        <div className="quiz_pop_body">
                            <div className="pop_content_wrap">Thank You for participating in this quiz. You may also be interested in this contest</div>
                            <div className="pop_img_wrap">
                                <a href="#">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/memoryimages/quiz-landing-page-final_03-1748614876306.jpg" alt="contest" title="contest"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
}

export default withLocation(Discussions);
